import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { vuetify } from './plugins/vuetify'
import { enableMocking } from './mocks'
import { useAuthStore } from './modules/auth/stores/auth.store'
import { vRole, vHasRole } from './shared/directives'

/**
 * Inicializar la aplicación
 * Se espera a que MSW esté listo antes de montar la app
 * para evitar race conditions con las primeras requests
 */
async function bootstrap() {
  // Habilitar mocking si está configurado
  await enableMocking()

  // Crear e inicializar la aplicación
  const app = createApp(App)
  const pinia = createPinia()

  app.use(pinia)
  app.use(router)
  app.use(vuetify)

  // Registrar directivas personalizadas
  app.directive('role', vRole)
  app.directive('has-role', vHasRole)

  // Restaurar sesión desde localStorage antes de montar la app
  // Esto asegura que el guard de autenticación tenga el estado correcto
  const authStore = useAuthStore()
  authStore.restoreSession()

  app.mount('#app')
}

// Iniciar la aplicación
bootstrap()
